/*
 * Copyright (c) 2025 Cozy Intellect Inc.
 * File Path: packages/sharedlib/src/stores/emailContacts.store.ts
 */

import { writable } from 'svelte/store';

export interface EmailContact {
  id: string;
  label: string;
  avatar?: string;
  data?: Record<string, unknown>;
}

// Store for email contacts used in mentions
export const emailContacts = writable<EmailContact[]>([]);

// Store for tracking loading state
export const emailContactsLoaded = writable<boolean>(false);

// Helper function to update email contacts
export const setEmailContacts = (contacts: EmailContact[]) => {
  emailContacts.set(contacts);
  emailContactsLoaded.set(true);
};

// Helper function to add a contact
export const addEmailContact = (contact: EmailContact) => {
  emailContacts.update((contacts) => [...contacts, contact]);
};

// Helper function to clear contacts
export const clearEmailContacts = () => {
  emailContacts.set([]);
  emailContactsLoaded.set(false);
};
